import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import Add from 'wix-ui-icons-common/Add';
import { PageSubtitle } from './PageSubtitle/PageSubtitle';
import TeamDetails from '../TeamDetails/TeamDetails';
import RolesListContainer from './RolesListContainer';
import { Link, withRouter } from 'react-router-dom';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { RouteChildrenProps } from 'react-router';
import { getIsSite, getLocale } from '../../redux/selectors/config';
import { State } from '../../redux/configure-store';
import { reportCreateCustomRoleClick } from '../../redux/actions/bi.actions';
import { getManageRolesPermission } from '../../redux/selectors/teamDetails';
import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';
import { getRoleIdsFromState } from '../../redux/selectors/table';

import { Button, Container, Row, Page, Tooltip } from 'wix-style-react';

interface IRolesListPage extends InjectedTranslateProps, RouteChildrenProps, ConnectedProps<typeof connector> {
}

const AddRoleButton = ({ t, isButtonDisabled, clickAddNewRole }) => (
  <Tooltip
    content={t('rolesList.addRoleCTA.noPermissions')}
    disabled={!isButtonDisabled}
    placement="left"
    maxWidth={259}>
      <Button
          dataHook="add-role-button"
          prefixIcon={<Add />}
          as={Link}
          to={'/role/new'}
          disabled={isButtonDisabled}
          onClick={clickAddNewRole}>
        {t('rolesList.addRoleCTA')}
      </Button>
  </Tooltip>
);

const RolesListPage: React.FC<IRolesListPage> = ({ t, match, locale, createRolePermission, clickAddNewRole, roleIds }) => {

  const history = useHistory();

  const isSite = useSelector(getIsSite);

  const onBackAction = useCallback(() => history.push('/'), [history]);

  return (
    <Page height="calc(100vh - 48px)">
      <Page.Header
        showBackButton
        onBackClicked={onBackAction}
        dataHook="account-team-header"
        title={t('app.teamRoles')}
        subtitle={<PageSubtitle locale={locale} isSite={isSite}/>}
        breadcrumbs={
          <Breadcrumbs routePath={match.path}/>
        }
        actionsBar={
          <AddRoleButton
            t={t}
            isButtonDisabled={!createRolePermission}
            clickAddNewRole={clickAddNewRole}
          />
        }
      />

      <Page.Content>
        <Container>
          <Row>
            <RolesListContainer header={<TeamDetails />} roleIds={roleIds}/>
          </Row>
        </Container>
      </Page.Content>
    </Page>
  );
};

const connector = connect(
  (state: State) => ({
    locale: getLocale(state),
    createRolePermission: getManageRolesPermission(state),
    roleIds: getRoleIdsFromState(state),
  }),
  {
    clickAddNewRole: () => reportCreateCustomRoleClick('/roles'),
  });
export default withRouter(connector(translate()(RolesListPage)));
